import React, { useMemo, useState, useEffect } from 'react';
import {
  Box,
  Grid,
  TextField,
  Typography,
  Button,
  Paper,
  Divider,
  useMediaQuery,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Alert,
  Checkbox,
  Card,
  CardContent,
  Chip,
  IconButton,
  Collapse,InputLabel,Select,MenuItem,FormHelperText 
} from '@mui/material';
import { Close, Error, Clear, BusAlertSharp, Fastfood } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import UserPageLayout from '../../components/user/UserPageLayout';
import { replace, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useRestaurant } from '../../contexts/RestaurantContext';
import { restaurantService } from "../../services/restaurantService";
import { useNotification } from '../../contexts/NotificationContext';
import { orderService } from '../../services/orderService';
import { CheckoutPageSkeleton } from '../../components/common/SkeletonLoader';
import { create_address, get_address ,edit_address} from '../../services/profileService';
import {
  LocalShipping,
  TakeoutDining,
  Payment,
  Person,
  LocationOn,
  Schedule,
  ExpandMore,
  ExpandLess,
  Add,
  Remove,
  Edit,
} from '@mui/icons-material';
import outletService from '../../services/outletService';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { publicOrderStatusUpdate } from '../../services/publicOrderStatusService';
import CommonModal from '../../components/common/CommonModal'
import CircularProgress from '@mui/material/CircularProgress';
import { getAuth, getAddressUsingPincode } from '../../services/onemapService';
import { get_distance_data } from '../../services/lalamoveService'
import { saveSessionID } from '../../services/feedBackService';


const CheckoutPage = () => {
  const [searchParams] = useSearchParams()
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();
  const location = useLocation();
  const { cart, getCartTotal, clearCart, outlets, selectedOutlet, isDeliveryAvailable, taxInfo, setTaxInfo, loginUser, updateCartItemQuantity, businessHours } = useRestaurant();
  const { showSuccess, showError } = useNotification();
  // console.log(cart, "cart")
  const orderType = location?.state?.serviceType || location?.state?.orderType || localStorage.getItem("preference") || 'delivery';
  const userInfo = loginUser || location.state?.userInfo || JSON.parse(sessionStorage.getItem('userInfo') || '{}');


  // console.log("Selected Outlet => ", selectedOutlet)
  // console.log(businessHours)

  const [form, setForm] = useState({
    outlet_id: null,
    customer_name: userInfo.username || userInfo.name || '',
    customer_phone: userInfo.phone || '',
    customer_email: userInfo.email || '',
    building_name: '',
    block_number_and_street_name: '',
    unit_number: '',
    pincode: '',
    delivery_instructions: '',
  });
  const [paymentMethod, setPaymentMethod] = useState('');
  const [pickupTime, setPickupTime] = useState('');
  const [deliveryTime, setDeliveryTime] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [orderCreated, setOrderCreated] = useState(false);
  const [createdOrder, setCreatedOrder] = useState(null);
  const [addressChecked, setAddressChecked] = useState(false);
  const [addressName, setAddresName] = useState("");
  const [expandedSection, setExpandedSection] = useState('contact');
  const [minTime, setMinTime] = useState()
  const [maxTime, setMaxTime] = useState()
  const [selectedDate, setSelectedDate] = useState(new Date())
  const [selectedDeliveryDate, setSelectedDeliveryDate] = useState(new Date())
  const [savedAddresses, setSavedAddresses] = useState([])
  const [cartItems, setCartItems] = useState([])
  const [cartItemsTotal, setCartItemsTotal] = useState(0);
  const [countryNoLength, setCountryNoLength] = useState(0)
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [editSavedAddress, setEditSavedAddress] = useState(false)
  const [paymentStatus, setPaymentStatus] = useState("")
const [paymentRedirectModalOpen, setPaymentRedirectModalOpen] = useState(false)
  const [deliveryPeriod, setDeliveryPeriod] = useState("now")
  const [outletOpeningTime, setOutletOpeningTime] = useState(null)
  const [deliveryNowModalOpen, setDeliveryNowModalOpen] = useState(false)
  const [outletClosed, setOutletClosed] = useState(false)
  const [lalamoveIsEnabled, setlalamoveIsEnabled] = useState(false)
  const [lalamoveDeliveryFee, setLalamoveDeliveryFee] = useState(0)
  const [deliveryFee, setDeliveryFee] = useState(taxInfo?.delivery_fee)
  const [isTimeValid, setIsTimeValid] = useState(false);
  const [timeError, setTimeError] = useState("")

  const [validatedSteps, setValidatedSteps] = useState({
    contact: true,
    delivery: false,
    payment: false
  });

  const [fieldErrors, setFieldErrors] = useState({
    customer_name: '',
    customer_phone: '',
    building_name: '',
    block_number_and_street_name: '',
    unit_number: '',
    pincode: ''
  });

  const primaryColor = '#680000';
  const primaryLight = 'rgba(104, 0, 0, 0.08)';
  const primaryDark = '#4a0000';


  const todayCheckDeliveryTime = () => {
    const today = new Date();

    const days = [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ];

    const dayName = days[today.getDay()];
     const outletId = JSON.parse(sessionStorage.getItem("selectedOutletId"));

    const selectedOutlet = outlets.find(
      (outlet) => String(outlet.id) === String(outletId)
    );
    // console.log("Outlets => ", outlets)
    const OutletBusinessHours = selectedOutlet?.business_hours;
    //  console.log("Day Hours Here => ",OutletBusinessHours )
    const dayHours = OutletBusinessHours?.[dayName];
    
    if (!dayHours?.open) {
      return false;
    }

    const openTime = dayHours.open; // "11:30"
    console.log(openTime)
    setOutletOpeningTime(openTime)

    // Current time in minutes
    const currentMinutes = today.getHours() * 60 + today.getMinutes();

    // Opening time in minutes
    const [openHour, openMinute] = openTime.split(":").map(Number);
    const openMinutes = openHour * 60 + openMinute;

    // console.log("Open Time =>", openTime);
    // console.log("Current Minutes =>", currentMinutes);
    // console.log("Open Minutes =>", openMinutes);

    // false if current time is before opening time
    return currentMinutes >= openMinutes;
  };


   const handleUpdateAddress = async () => {
    // console.log("Form => ", form)
    // console.log("Address ID ", selectedAddressId)
    let payload = {
      ...form,
      "id": selectedAddressId
    }
    try {
      const response = await edit_address(payload)
      showSuccess("Address Updated Successfully");
      setEditSavedAddress(false)
    }
    catch (error) {
      console.error("Error While Update Address")
    }
  }

  // Helper function to find next open day
  const findNextOpenDay = (startDate, daysToAdd = 1) => {
    const days = [
      "sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"
    ];

    let currentDate = new Date(startDate);
    let found = false;
    let attempts = 0;

    while (!found && attempts < 7) {
      currentDate.setDate(currentDate.getDate() + daysToAdd);
      const dayIndex = currentDate.getDay();
      const dayName = days[dayIndex];
      const dayHours = businessHours?.[dayName];

      if (dayHours && !dayHours.closed) {
        const [openH, openM] = dayHours.open.split(":");
        const [closeH, closeM] = dayHours.close.split(":");

        const openTime = new Date(currentDate);
        openTime.setHours(parseInt(openH), parseInt(openM), 0, 0);

        const closeTime = new Date(currentDate);
        closeTime.setHours(parseInt(closeH), parseInt(closeM), 0, 0);

        // console.log(`Found next open day: ${dayName}`, openTime, closeTime);
        return { minDateTime: openTime, maxDateTime: closeTime, found: true };
      }
      attempts++;
    }

    // If no open day found, use tomorrow with default times
    const defaultDate = new Date(startDate);
    defaultDate.setDate(defaultDate.getDate() + 1);
    const minDateTime = new Date(defaultDate);
    minDateTime.setHours(9, 0, 0, 0); // 09:00
    const maxDateTime = new Date(defaultDate);
    maxDateTime.setHours(22, 0, 0, 0); // 22:00

    return { minDateTime, maxDateTime, found: false };
  };

  // const calculatePickupTimeRange = (date = new Date()) => {
  //   const days = [
  //     "sunday",
  //     "monday",
  //     "tuesday",
  //     "wednesday",
  //     "thursday",
  //     "friday",
  //     "saturday"
  //   ];

  //   const selectedDate = new Date(date);
  //   const currentDate = new Date();

  //   // Check if selected date is today
  //   const isToday =
  //     selectedDate.getDate() === currentDate.getDate() &&
  //     selectedDate.getMonth() === currentDate.getMonth() &&
  //     selectedDate.getFullYear() === currentDate.getFullYear();

  //   const dayOfWeek = selectedDate.getDay();
  //   const dayName = days[dayOfWeek];
  //   const dayHours = businessHours?.[dayName];

  //   let minDateTime = null;
  //   let maxDateTime = null;

  //   if (dayHours && !dayHours.closed) {
  //     const [openH, openM] = dayHours.open.split(":");
  //     const [closeH, closeM] = dayHours.close.split(":");

  //     // Create date objects for the selected date's open and close times
  //     const openTime = new Date(selectedDate);
  //     openTime.setHours(parseInt(openH), parseInt(openM), 0, 0);

  //     const closeTime = new Date(selectedDate);
  //     closeTime.setHours(parseInt(closeH), parseInt(closeM), 0, 0);

  //     // console.log("Selected Date:", selectedDate);
  //     console.log("Open Time:", openTime);
  //     console.log("Close Time:", closeTime);
  //     // console.log("Is Today?", isToday);

  //     // If it's TODAY, apply restrictions
  //     if (isToday) {
  //       const now = new Date();

  //       // CASE 1 — Before opening → min = open time
  //       if (now < openTime) {

  //         minDateTime = openTime;
  //         maxDateTime = closeTime;
  //       }
  //       // CASE 2 — Within business hours
  //       else if (now >= openTime && now <= closeTime) {
  //         // Calculate exactly 1 hour from now (same minutes)
  //         const oneHourLater = new Date(now);
  //         oneHourLater.setHours(oneHourLater.getHours() + 1);
  //         oneHourLater.setSeconds(0);
  //         oneHourLater.setMilliseconds(0);

  //         // console.log("One hour later:", oneHourLater);

  //         // Make sure we don't exceed closing time
  //         if (oneHourLater > closeTime) {
  //           // Find next open day if we exceed today's closing time
  //           const result = findNextOpenDay(now, 1);
  //           minDateTime = result.minDateTime;
  //           maxDateTime = result.maxDateTime;
  //         } else {
  //           minDateTime = oneHourLater;
  //           maxDateTime = closeTime;
  //         }
  //       }
  //       // CASE 3 — After closing → use tomorrow's schedule
  //       else {
  //         const result = findNextOpenDay(now, 1);
  //         minDateTime = result.minDateTime;
  //         maxDateTime = result.maxDateTime;
  //       }
  //     }
  //     // If it's a FUTURE date, show full range of that day's hours
  //     else {
  //       minDateTime = openTime;
  //       maxDateTime = closeTime;
  //     }
  //   } else {
  //     // BUSINESS CLOSED on selected date
  //     const result = findNextOpenDay(selectedDate, 1);
  //     minDateTime = result.minDateTime;
  //     maxDateTime = result.maxDateTime;
  //   }

  //   // console.log("MIN =>", minDateTime);
  //   // console.log("MAX =>", maxDateTime);

  //   return { minDateTime, maxDateTime };
  // };


  const calculatePickupTimeRange = (date = new Date()) => {
    const days = [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday"
    ];

    const selectedDate = new Date(date);
    const currentDate = new Date();

    // Check if selected date is today
    const isToday =
      selectedDate.getDate() === currentDate.getDate() &&
      selectedDate.getMonth() === currentDate.getMonth() &&
      selectedDate.getFullYear() === currentDate.getFullYear();

    const dayOfWeek = selectedDate.getDay();
    const dayName = days[dayOfWeek];
    const dayHours = businessHours?.[dayName];

    console.log("Day Hours => ", dayHours);

    let minDateTime = null;
    let maxDateTime = null;

    if (dayHours && !dayHours.closed) {
      const [openH, openM] = dayHours.open.split(":");
      const [closeH, closeM] = dayHours.close.split(":");

      // Create date objects for the selected date's open and close times
      const openTime = new Date(selectedDate);
      openTime.setHours(parseInt(openH), parseInt(openM), 0, 0);

      const closeTime = new Date(selectedDate);
      closeTime.setHours(parseInt(closeH), parseInt(closeM), 0, 0);

      // If it's TODAY, apply restrictions
      if (isToday) {
        const now = new Date();

        // CASE 1 — Before opening → min = open time
        if (now < openTime) {
          minDateTime = openTime;
          maxDateTime = closeTime;
        }
        // CASE 2 — Within business hours
        else if (now >= openTime && now <= closeTime) {
          // Calculate exactly 1 hour from now (same minutes)
          const oneHourLater = new Date(now);
          oneHourLater.setHours(oneHourLater.getHours() + 1);
          oneHourLater.setSeconds(0);
          oneHourLater.setMilliseconds(0);

          // Calculate time 1 hour before closing
          const oneHourBeforeClose = new Date(closeTime);
          oneHourBeforeClose.setHours(oneHourBeforeClose.getHours() - 1);

          // NEW CASE: If current time is within the last hour before closing
          // (e.g., 2:30 PM when closing is 3:00 PM)
          if (now >= oneHourBeforeClose) {
            // Only allow the closing time as the available option
            minDateTime = closeTime;
            maxDateTime = closeTime;
          }
          // CASE: If ordering 1 hour later would exceed closing time
          else if (oneHourLater > closeTime) {
            // Only allow the closing time
            minDateTime = closeTime;
            maxDateTime = closeTime;
          }
          // Normal case - show times from 1 hour later until closing
          else {
            minDateTime = oneHourLater;
            maxDateTime = closeTime;
          }
        }
        // CASE 3 — After closing → use tomorrow's schedule
        else {
          const result = findNextOpenDay(now, 1);
          minDateTime = result.minDateTime;
          maxDateTime = result.maxDateTime;
        }
      }
      // If it's a FUTURE date, show full range of that day's hours
      else {
        minDateTime = openTime;
        maxDateTime = closeTime;
      }
    } else {
      // BUSINESS CLOSED on selected date
      const result = findNextOpenDay(selectedDate, 1);
      minDateTime = result.minDateTime;
      maxDateTime = result.maxDateTime;
    }

    console.log("MIn Date Time => ", minDateTime);
    console.log("Max Date Time => ", maxDateTime);

    return { minDateTime, maxDateTime };
  };

  const isTimeGreaterThanOneHour = (selectedTime, selectedDateObj) => {
    if (!selectedTime) return false;

    // Get current time
    const now = new Date();

    // Parse selected time
    const [hours, minutes] = selectedTime.split(':').map(Number);
    const selectedDateTime = new Date(selectedDateObj);
    selectedDateTime.setHours(hours, minutes, 0, 0);

    // Calculate 1 hour from now
    const oneHourFromNow = new Date(now);
    oneHourFromNow.setHours(oneHourFromNow.getHours() + 1);

    // Check if selected time is at least 1 hour from now
    return selectedDateTime >= oneHourFromNow;
  };

  useEffect(() => {
    if (!localStorage.getItem('cart_items')) {
      navigate("/")
    }

    let status = searchParams.get('status') || ""
    setPaymentStatus(status)
    if (status !== "") {
      setPaymentRedirectModalOpen(true)
    }
    else if (status === "canceled") {
      setPaymentRedirectModalOpen(false)
    }

    async function updateStatus(order_id, status_val) {
      let status = {
        "status": "failed"
      }
      try {
        const response = await publicOrderStatusUpdate(order_id, status)
        // console.log("Response => ", response)
      }
      catch (error) {
        // console.error("Error Happened on Update Status")
      }
    }

    if (status === "canceled") {
      let order = JSON.parse(sessionStorage.getItem("pendingOrder"))
      // console.log("Order in IF => ", order)
      updateStatus(order.id, "failed")
    }

  }, [])

  // Set outlet_id when outlets are loaded
  useEffect(() => {
    // let status = searchParams.get('status') || ""
    // setPaymentStatus(status)
    // if (status !== "") {
    //   setPaymentRedirectModalOpen(true)
    // }
    // else if (status === "canceled") {
    //   setPaymentRedirectModalOpen(false)
    // }

    // async function updateStatus(order_id, status_val) {
    //   let status = {
    //     "status": "failed"
    //   }
    //   try {
    //     const response = await publicOrderStatusUpdate(order_id, status)
    //     // console.log("Response => ", response)
    //   }
    //   catch (error) {
    //     // console.error("Error Happened on Update Status")
    //   }
    // }

    // if (status === "canceled") {
    // let order = JSON.parse(sessionStorage.getItem("pendingOrder"))
    // console.log("Order in IF => ", order)
    // updateStatus(order.id, "failed")
    // }

    // Initialize with today's time range
    const initialTimeRange = calculatePickupTimeRange(new Date());
    setMinTime(initialTimeRange.minDateTime);
    setMaxTime(initialTimeRange.maxDateTime);

    if (selectedOutlet && selectedOutlet.id) {
      setForm(prev => ({ ...prev, outlet_id: selectedOutlet.id }));
    } else if (outlets && outlets.length > 0 && !form.outlet_id) {
      setForm(prev => ({ ...prev, outlet_id: outlets[0].id }));
    }

    async function getAddress() {
      try {
        const response = await get_address(loginUser.id)
        // console.log(response.data)
        setSavedAddresses(response.data)
      }
      catch (error) {
        console.error("Error Occured => ", error)
      }
    }

    if (loginUser) {
      getAddress()
    }

    const getTax = async (outlet_id) => {
      try {
        const response = await outletService.getTaxDetails(outlet_id);
        let gst_value = (response.gst / 100)
        response.gst = gst_value;
        sessionStorage.setItem('tax', JSON.stringify(response));
        setTaxInfo(response)
        // console.log("Tax is Getting => ", response)
      }
      catch (error) {
        console.error("Error on Getting Tax => ", error)
      }
    }

    const selectedOutletId = sessionStorage.getItem("selectedOutletId");
    if (selectedOutletId) {
      getTax(parseInt(selectedOutletId))
    }

    // console.log("Busineess Hours => ", )
    let status = searchParams.get('status') || ""
    if (orderType == "delivery" && status === "" && deliveryPeriod === 'now' && !todayCheckDeliveryTime()) {
      setDeliveryNowModalOpen(true)
    }

  }, [outlets, selectedOutlet, form.outlet_id, businessHours, deliveryPeriod]);

  async function fetchCartItems() {
    try {
      const response = await restaurantService.getCartItems(localStorage.getItem('cart_id'));
      setCartItems(response.cart_items)
      setCartItemsTotal(response.cart_total)
    }
    catch (error) {
      console.error("Error on Getting Cart Items", error)
    }
  }

  const handleDeliveryDateChange = async (dateValue) => {
    const date = new Date(dateValue);
    const dayIndex = date.getDay();
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    let day = days[dayIndex];
    day = day.toLowerCase()

    try {
      const response = await outletService.getSpecifcOutletTimingsDay(form.outlet_id, day);
      // console.log(response[day])
      setOutletClosed(response[day].closed)
    }
    catch (error) {
      console.error("Error Happened => ", error)
    }
  }




  useEffect(() => {
    // console.log("Yes Here in Cart Drawer")
    fetchCartItems();
  }, [])

  function combineDateTime(selectedDate, timeString) {
    // console.log('=== DEBUG combineDateTime ===');
    // console.log('selectedDate:', selectedDate);
    // console.log('timeString:', timeString);

    // Validate inputs
    if (!selectedDate || !timeString) {
      console.error('Missing date or time');
      return null;
    }

    // Ensure selectedDate is a valid Date
    if (!(selectedDate instanceof Date) || isNaN(selectedDate.getTime())) {
      console.error('Invalid selectedDate');
      return null;
    }

    try {
      // Parse time string (format: "HH:MM:00")
      const timeParts = timeString.split(':');
      if (timeParts.length < 2) {
        console.error('Invalid time format');
        return null;
      }

      const hours = parseInt(timeParts[0], 10);
      const minutes = parseInt(timeParts[1], 10);
      const seconds = timeParts[2] ? parseInt(timeParts[2], 10) : 0;

      // Validate time
      if (isNaN(hours) || isNaN(minutes) || isNaN(seconds) ||
        hours < 0 || hours > 23 ||
        minutes < 0 || minutes > 59 ||
        seconds < 0 || seconds > 59) {
        console.error('Invalid time values:', { hours, minutes, seconds });
        return null;
      }

      // Create new date object with the selected date
      const combinedDate = new Date(selectedDate);

      // Set the time (this handles timezone correctly)
      combinedDate.setHours(hours, minutes, seconds, 0);

      // console.log('Combined date:', combinedDate);
      // console.log('Combined date toString:', combinedDate.toString());
      // console.log('Is valid?', !isNaN(combinedDate.getTime()));

      if (isNaN(combinedDate.getTime())) {
        console.error('Invalid date created');
        return null;
      }

      const isoString = combinedDate.toISOString();
      // console.log('ISO String:', isoString);
      // console.log('=== END DEBUG ===');

      return isoString; // Returns format: 2026-01-10T10:45:00.000Z

    } catch (error) {
      console.error('Error in combineDateTime:', error);
      return null;
    }
  }

  // Function to handle address selection
  const handleAddressSelect = (address) => {
    setSelectedAddressId(address.id);
    setForm({
      ...form,
      building_name: address.building_name,
      block_number_and_street_name: address.block_number_and_street_name,
      unit_number: address.unit_number,
      pincode: address.pincode
    });
  };

  // Function to clear selected address and reset form
  const handleClearSelectedAddress = () => {
    setSelectedAddressId(null);
    setForm({
      ...form,
      building_name: '',
      block_number_and_street_name: '',
      unit_number: '',
      pincode: ''
    });
  };

  // Validation functions for each step
  const validateContactStep = () => {
    const errors = {};
    let isValid = true;

    if (!form.customer_name.trim()) {
      errors.customer_name = 'Full name is required';
      isValid = false;
    }

    if (!form.customer_phone.trim()) {
      errors.customer_phone = 'Phone number is required';
      isValid = false;
    } else if (!/^\d{8,}$/.test(form.customer_phone.replace(/\D/g, ''))) {
      errors.customer_phone = 'Please enter a valid phone number (at least 8 digits)';
      isValid = false;
    }

    // console.log("Checking Number Validation => ", form.customer_phone.trim().length + " === " + countryNoLength);

    setFieldErrors(prev => ({ ...prev, ...errors }));

    if (isValid) {
      setValidatedSteps(prev => ({ ...prev, contact: true }));
      setExpandedSection('delivery');
    }

    return isValid;
  };

  const validateDeliveryStep = () => {
    if (orderType !== 'delivery') {
      setValidatedSteps(prev => ({ ...prev, delivery: true }));
      setExpandedSection('payment');
      return true;
    }

    const errors = {};
    let isValid = true;

    if (!form.building_name.trim()) {
      errors.building_name = 'Building name is required';
      isValid = false;
    }

    if (!form.block_number_and_street_name.trim()) {
      errors.block_number_and_street_name = 'Block and Street Name is required';
      isValid = false;
    }

    if (!form.unit_number.trim()) {
      errors.unit_number = 'Street address is required';
      isValid = false;
    }

    if (!form.pincode.trim()) {
      errors.pincode = 'Pin code is required';
      isValid = false;
    } else if (!/^\d{6}$/.test(form.pincode.trim())) {
      errors.pincode = 'Please enter a valid 6-digit Singapore Pin code';
      isValid = false;
    }

    setFieldErrors(prev => ({ ...prev, ...errors }));

    if (isValid) {
      setValidatedSteps(prev => ({ ...prev, delivery: true }));
      setExpandedSection('payment');
    }

    return isValid;
  };

  const validatePaymentStep = () => {
    if (!paymentMethod) {
      setFieldErrors(prev => ({ ...prev, payment: 'Please select a payment method' }));
      return false;
    }

    setValidatedSteps(prev => ({ ...prev, payment: true }));
    setFieldErrors(prev => ({ ...prev, payment: '' }));
    return true;
  };

  // Check if contact step is valid for enabling continue button
  const isContactStepValid = () => {
    return (
      form.customer_name.trim() !== '' &&
      form.customer_phone.trim() !== '' &&
      new RegExp(`^\\d{${countryNoLength},}$`)
        .test(form.customer_phone.replace(/\D/g, ''))
    );
  };

  // Check if delivery step is valid for enabling continue button
  // const isDeliveryStepValid = () => {
  //   if (orderType === 'takeaway') {
  //     if (pickupTime === "") {
  //       return false
  //     }
  //     return true
  //   }
  //   else if (orderType === "delivery" && deliveryPeriod === "later") {
  //     if (selectedDate === "" && deliveryTime === "") {
  //       return false
  //     }
  //   }

  //   return form?.building_name?.trim() !== '' &&
  //     form?.block_number_and_street_name?.trim() !== '' &&
  //     form?.unit_number?.trim() !== '' &&
  //     form?.pincode?.trim() !== '' &&
  //     /^\d{6}$/.test(form?.pincode?.trim());
  // };

  // Remove setIsTimeValid from this function
  const isDeliveryStepValid = () => {
    // For takeaway orders
    if (orderType === 'takeaway') {
      // Check if pickup time is selected AND is at least 1 hour from now
      if (!pickupTime) {
        return false;
      }
      return isTimeGreaterThanOneHour(pickupTime, selectedDate);
    }

    // For delivery orders
    else if (orderType === "delivery") {
      // If delivery is later, check if delivery time is selected AND valid
      if (deliveryPeriod === "later") {
        if (!deliveryTime) {
          return false;
        }
        const isValid = isTimeGreaterThanOneHour(deliveryTime, selectedDate);
        if (!isValid) return false;
      }

      // Check address fields
      return form?.building_name?.trim() !== '' &&
        form?.block_number_and_street_name?.trim() !== '' &&
        form?.unit_number?.trim() !== '' &&
        form?.pincode?.trim() !== '' &&
        /^\d{6}$/.test(form?.pincode?.trim());
    }

    return true;
  };

  // Check if payment step is valid for enabling continue button
  const isPaymentStepValid = () => {
    return paymentMethod !== '';
  };

  const handleNumberChange = (field, e) => {
    let phoneNumber_Length = e.target.countryValue.format.split('.').length - 1;
    setCountryNoLength(phoneNumber_Length)
    setForm({ ...form, [field]: e.target.value })
  }

  const validateDeliveryAddress = () => {

    const pincode = form?.pincode?.trim();
    const blockStreet = form?.block_number_and_street_name?.trim();
    const hasPincodeInAddress = pincode && blockStreet?.endsWith(pincode);
    return hasPincodeInAddress ? `${form.unit_number}^${form.building_name}^${blockStreet}` : `${form.unit_number}^${form.building_name}^${blockStreet}^${pincode}`;
  }

  const toOrderPayload = () => {
    let actual_delivery_fee = 0;
    if (taxInfo?.free_delivery === 0) {
      actual_delivery_fee += deliveryFee
    }
    else if (taxInfo?.free_delivery === "") {
      actual_delivery_fee = 0;
    }
    else if (taxInfo?.free_delivery > 0 && summary.subtotal < taxInfo?.free_delivery) {
      actual_delivery_fee += deliveryFee;
    }

    return {
      outlet_id: form.outlet_id,
      customer_name: form.customer_name,
      customer_phone: form.customer_phone,
      customer_email: form.customer_email || undefined,
      delivery_address: orderType === 'delivery' ?
        validateDeliveryAddress() : undefined,
      delivery_instructions: form.delivery_instructions,
      items: cart.map(ci => ({
        menu_item_id: ci.id,
        quantity: ci.quantity || 1,
        size_name: ci.selectedSize?.name || null,
        size_price: ci.selectedSize?.price_modifier || 0,
        base_price: ci.base_price || ci.price || 0,
        total_price: (ci.price || ci.base_price || 0) * (ci.quantity || 1),
        special_instructions: ci.special_instructions || undefined,
        addons: (ci.addons || []).map(a => ({ addon_id: a.id, quantity: a.quantity || 1, price: a.price }))
      })),
      subtotal: summary.subtotal,
      tax_amount: summary.gst_value,
      delivery_fee: actual_delivery_fee,
      lalamove: taxInfo?.lalamove,
      discount_amount: cart.reduce((sum, item) => {
        if (item.discount_enabled && item.discount_percentage > 0) {
          const originalTotal = item.original_price * item.quantity;
          const discountedTotal = item.discounted_price * item.quantity;
          return sum + (originalTotal - discountedTotal);
        }
        return sum;
      }, 0),
      total_amount: summary.total_amount,
      special_instructions: undefined,
      payment_method: paymentMethod,
      delivery_period: deliveryPeriod,
      ...(orderType === 'takeaway' && pickupTime && { delivery_or_pickup_time: combineDateTime(selectedDate, pickupTime) }),
      ...(orderType === 'delivery' && deliveryTime && { delivery_or_pickup_time: combineDateTime(selectedDate, deliveryTime) }),
    };
  };

  const validateForm = () => {
    const errors = [];

    if (!cart || cart.length === 0) {
      errors.push('Your cart is empty. Please add items before requesting an order.');
    }

    if (!form.outlet_id) {
      errors.push('Please select an outlet for your order.');
    }

    if (!form.customer_name.trim()) {
      errors.push('Full name is required');
    }

    if (!form.customer_phone.trim()) {
      errors.push('Phone number is required');
    }

    if (orderType === 'delivery' && !isDeliveryAvailable()) {
      errors.push('Delivery service is not available at this outlet. Please choose takeaway or dine-in instead.');
    }

    if (orderType === 'delivery' && isDeliveryAvailable()) {
      if (!form.building_name.trim()) {
        errors.push('Building name is required for delivery orders.');
      }
      if (!form.block_number_and_street_name.trim()) {
        errors.push('building_number is required for delivery orders.');
      }
      if (!form.unit_number.trim()) {
        errors.push('Street address is required for delivery orders.');
      }
      if (!form.pincode.trim()) {
        errors.push('Pin Code is required for delivery orders.');
      }
      if (form.pincode.trim() && !/^\d{6}$/.test(form.pincode.trim())) {
        errors.push('Please enter a valid Singapore Pin code (6 digits).');
      }
    }

    return errors;
  };

  const handlePlaceOrder = async () => {
    // Check if all steps are validated
    if (!validatedSteps.contact || !validatedSteps.delivery || !validatedSteps.payment) {
      showError('Please complete all steps before placing your order.');
      return;
    }

    if (deliveryPeriod === "later" && selectedDate && (deliveryTime === "" || deliveryTime === null)) {
      showError("Please Select Delivery Time")
      return;
    }

    const errors = validateForm();
    if (errors.length > 0) {
      showError('Please fix the following errors:\n' + errors.join('\n'));
      return;
    }

    // Validate pickup time for takeaway orders
    if (orderType === 'takeaway') {
      const combinedTime = combineDateTime(selectedDate, pickupTime);
      if (!combinedTime) {
        showError('Please select a valid date and time for pickup.');
        setSubmitting(false);
        return;
      }
      // console.log('Pickup time for order:', combinedTime);
    }

    if (addressChecked) {
      try {
        let data = {
          "address_name": addressName,
          "building_name": form.building_name,
          "block_number_and_street_name": form.block_number_and_street_name,
          "unit_number": form.unit_number,
          "pincode": form.pincode
        }
        const response = await create_address(data);
      } catch (error) {
        console.error("Error creating address:", error);
      }
    }

    setSubmitting(true);
    setPaymentRedirectModalOpen(true)
    try {
      const orderEndpoint = orderType === 'delivery' ? 'delivery' : 'takeaway';
      const payload = toOrderPayload();

      // console.log('Creating order with payload:', JSON.stringify(payload, null, 2));

      const order = await orderService.createOrder(orderEndpoint, payload);
      setCreatedOrder(order);
      setOrderCreated(true);
      let guest_id = localStorage.getItem("device_uuid");
      let payloadToo = {
        "guest_id": guest_id,
        "order_id": order?.id
      }

      try {
        const response = await saveSessionID(payloadToo);
      }
      catch (error) {
        console.error("Error => ", error)
      }


      // Payment processing logic remains the same as your original code
      if (paymentMethod === 'paynow' || paymentMethod === 'grabpay' || paymentMethod === "card" || paymentMethod === "upi") {
        try {
          // console.log("Yes Here the Payment Method => ", paymentMethod)
          const hp = await orderService.createHitpayPayment(order.id);
          if (hp?.checkout_url) {
            sessionStorage.setItem('pendingOrder', JSON.stringify({
              id: order.id,
              order_number: order.order_number,
              total_amount: order.total_amount,
              order_type: orderType,
              customer_name: form.customer_name,
              customer_phone: form.customer_phone,
              customer_email: form.customer_email,
              unique_string: order.unique_string,
              payment_method: paymentMethod.toUpperCase()
            }));
            window.location.href = hp.checkout_url;
          } else {
            navigate('/payment/failed', {
              state: {
                status: 'failed',
                order: {
                  id: order.id,
                  order_number: order.order_number,
                  total_amount: order.total_amount,
                  order_type: orderType,
                  customer_name: form.customer_name,
                  customer_phone: form.customer_phone,
                  customer_email: form.customer_email,
                  unique_string: order.unique_string
                }
              }
            });
          }
        } catch (error) {
          console.error('HitPay payment creation failed:', error);
          navigate('/payment/failed', {
            state: {
              status: 'failed',
              order: {
                id: order.id,
                order_number: order.order_number,
                total_amount: order.total_amount,
                order_type: orderType,
                customer_name: form.customer_name,
                customer_phone: form.customer_phone,
                customer_email: form.customer_email
              }
            }
          });
        }
      } else if (paymentMethod === 'cash_on_delivery') {
        try {
          const paymentData = {
            provider_payment_id: `cash_${order.id}_${Date.now()}`,
            payment_method: paymentMethod,
            amount: order.total_amount,
            currency: 'SGD',
            payment_metadata: {
              order_id: order.id,
              order_number: order.order_number,
              payment_type: orderType,
              confirmed_at: new Date().toISOString()
            }
          };

          await orderService.confirmPayment(order.id, paymentData);
          // console.log('Cash payment confirmed successfully');

          clearCart && clearCart();
          navigate('/payment/success', {
            state: {
              status: 'success',
              order: {
                id: order.id,
                order_number: order.order_number,
                total_amount: order.total_amount,
                order_type: orderType,
                payment_method: 'cash_on_delivery',
                unique_string: order.unique_string
              }
            }
          });
        } catch (error) {
          console.error('Failed to confirm cash payment:', error);
          clearCart && clearCart();
          navigate('/payment/success', {
            state: {
              status: 'success',
              order: {
                id: order.id,
                order_number: order.order_number,
                total_amount: order.total_amount,
                order_type: orderType,
                payment_method: 'cash_on_delivery'
              }
            }
          });
        }
      } else if (['visa', 'mastercard', 'american_express', 'discover'].includes(paymentMethod)) {
        showSuccess('Card payment is coming soon! Please use "Pay Online (HitPay)" or "Cash on ' + (orderType === 'delivery' ? 'Delivery' : 'Pickup') + '" for now.');
        setSubmitting(false);
        return;
      }
    } catch (e) {
      console.error('Order creation/payment error:', e);
      let errorMessage = 'Failed to process order. Please try again.';

      if (e.response) {
        if (e.response.status === 422) {
          errorMessage = 'Validation error. Please check your order details and try again.';
        } else if (e.response.status === 400) {
          errorMessage = e.response.data?.detail || 'Invalid order data. Please check your details.';
        } else if (e.response.status === 403) {
          errorMessage = 'Access denied. Please check your order details and try again.';
        } else {
          errorMessage = `Server error (${e.response.status}). Please try again.`;
        }
      } else if (e.request) {
        errorMessage = 'Network error. Please check your connection and try again.';
      }
      setPaymentRedirectModalOpen(false)
      showError(e.response?.data?.detail)

    } finally {
      setSubmitting(false);
    }
  };

  const navigateAfterSuccess = () => {
    let order = JSON.parse(sessionStorage.getItem("pendingOrder"))
    clearCart && clearCart();
    navigate('/payment/success', {
      state: {
        status: 'success',
        order: {
          id: order.id,
          order_number: order.order_number,
          total_amount: order.total_amount,
          order_type: orderType,
          payment_method: order.payment_method,
          unique_string: order.unique_string
        }
      }
    });
  }

  const toggleSection = (section) => {
    // Don't allow expanding next sections if previous steps aren't validated
    if (section === 'delivery' && !validatedSteps.contact) {
      return;
    }
    if (section === 'payment' && !validatedSteps.delivery) {
      return;
    }
    setExpandedSection(expandedSection === section ? null : section);
  };

  const handleQuantityUpdate = (itemId, newQuantity) => {
    if (newQuantity < 1) return;
    if (updateCartItemQuantity) {
      updateCartItemQuantity(itemId, newQuantity);
    }
  };

  const calculatePlatformFee = (method, total) => {
    // console.log("Payment Method at calc=> ", method)
    if (method === "grabpay") method = "grab_pay";
    if (method === "paynow") method = "pay_now";
    // console.log(taxInfo.platform_fee[method])

    let result = {
      "fixed_charges": 0,
      "extra_charges": 0
    }

    if (taxInfo.platform_fee[method]?.fixed_charges.type === "percentage" && parseFloat(taxInfo.platform_fee[method]?.fixed_charges.value) > 0) {
      let value = (parseFloat(taxInfo.platform_fee[method]?.fixed_charges.value) / 100) * total
      // console.log("Value is => ", value)
      // value = 1 - value
      result["fixed_charges"] = value
    }
    else if (taxInfo.platform_fee[method]?.fixed_charges.type === "fixed" && parseFloat(taxInfo.platform_fee[method]?.fixed_charges.value) > 0) {
      result["fixed_charges"] = parseFloat(taxInfo.platform_fee[method]?.fixed_charges.value)
    }

    if (taxInfo.platform_fee[method]?.extra_charges.type === "percentage" && parseFloat(taxInfo.platform_fee[method]?.extra_charges.value) > 0) {
      let value = (parseFloat(taxInfo.platform_fee[method]?.extra_charges.value) / 100) * total
      // value = 1 - value
      result["extra_charges"] = value
    }
    else if (taxInfo.platform_fee[method]?.extra_charges.type === "fixed" && parseFloat(taxInfo.platform_fee[method]?.extra_charges.value) > 0) {
      result["extra_charges"] = parseFloat(taxInfo.platform_fee[method]?.extra_charges.value)
    }

    return result
  }

  const summary = useMemo(() => {
    const gstRate = taxInfo?.gst ?? 0.08;
    let subtotal = cartItemsTotal;
    let serviceChargeValue = 0;

    let total = subtotal;

    if (orderType === "delivery") {
      if (taxInfo?.free_delivery === 0) {
        // total += taxInfo?.delivery_fee;
        total += deliveryFee
      }
      else if (taxInfo?.free_delivery > 0 && subtotal < taxInfo?.free_delivery) {
        // total += taxInfo?.delivery_fee;
        total += deliveryFee
      }

    }
    let gst_value;
    if (taxInfo?.inclusive) {
      const amountWithoutGST = subtotal / (1 + gstRate);
      gst_value = subtotal - amountWithoutGST;
      subtotal = subtotal - gst_value
    } else {
      gst_value = subtotal * gstRate;
      total += gst_value;
    }


    let total_amount;

    let extra_charge = 0;
    let fixed_charge = 0



    total = Number(total.toFixed(2))
    // console.log("Total = ", total)  

    if (taxInfo.service_charge > 0) {
      serviceChargeValue = (taxInfo?.service_charge / 100) * subtotal
      total += serviceChargeValue
      serviceChargeValue = serviceChargeValue.toFixed(2)
    }
    // console.log("Total => ", total)

    let platform_fee_result = calculatePlatformFee(paymentMethod, total)

    // console.log("Platform Fee Result => ", platform_fee_result)

    extra_charge = platform_fee_result["extra_charges"]
    fixed_charge = platform_fee_result["fixed_charges"]

    let platform_fee = 0
    if (extra_charge > 0) {
      total += extra_charge
      platform_fee += extra_charge
    }

    if (fixed_charge > 0) {
      total += fixed_charge
      platform_fee += fixed_charge

    }

    total_amount = total
    // total_amount = Number(total_amount.toFixed(2))
    total_amount = Number((total_amount + Number.EPSILON).toFixed(2));
    // console.log("Total Amount => ", total_amount)

    gst_value = gst_value.toFixed(2);

    return { subtotal, total_amount, platform_fee, gst_value, serviceChargeValue };
  }, [getCartTotal, orderType, paymentMethod, cartItemsTotal, deliveryFee])

  // Show skeleton loader while loading
  if (!outlets || outlets.length === 0 || submitting) {
    return (
      <UserPageLayout title="Checkout" subtitle={`Confirm ${orderType} details and pay securely`}>
        <CheckoutPageSkeleton />
      </UserPageLayout>
    );
  }


  // Create this component in a separate file or at the top of your CheckoutPage
 const TimeDropdown = ({ value, onChange, minTime, maxTime, label, disabled = false, error = false, helperText = "" }) => {
  // Generate time options from 00:00 to 23:45 with 15-minute intervals
  const timeOptions = useMemo(() => {
    const options = [];
    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 15) {
        const hourStr = hour.toString().padStart(2, '0');
        const minuteStr = minute.toString().padStart(2, '0');
        const timeStr = `${hourStr}:${minuteStr}`;
        options.push(timeStr);
      }
    }
    return options;
  }, []);

  // Filter options based on minTime and maxTime if they exist
  const filteredOptions = useMemo(() => {
    if (!minTime || !maxTime) return timeOptions;

    const minHour = minTime.getHours();
    const minMinute = minTime.getMinutes();
    const maxHour = maxTime.getHours();
    const maxMinute = maxTime.getMinutes();

    return timeOptions.filter(timeStr => {
      const [hours, minutes] = timeStr.split(':').map(Number);
      const timeInMinutes = hours * 60 + minutes;
      const minInMinutes = minHour * 60 + minMinute;
      const maxInMinutes = maxHour * 60 + maxMinute;
      return timeInMinutes >= minInMinutes && timeInMinutes <= maxInMinutes;
    });
  }, [timeOptions, minTime, maxTime]);

  return (
    <FormControl fullWidth error={error} disabled={disabled} sx={{
      marginTop: '8px',
      width: '50%'
    }}>
      <InputLabel id={`time-dropdown-label-${label}`}>{label}</InputLabel>
      <Select
        labelId={`time-dropdown-label-${label}`}
        id={`time-dropdown-${label}`}
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        label={label}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 300,
            },
          },
        }}
        // sx={{
        //   '& .MuiSelect-select': {
        //     py: 1.5,
        //   },
        // }}
      >
        <MenuItem value="">
          <em>Select time</em>
        </MenuItem>
        {filteredOptions.map((time) => (
          <MenuItem key={time} value={time}>
            {time}
          </MenuItem>
        ))}
      </Select>
      {helperText && (
        <FormHelperText error={error}>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
};

  return (
    <Box sx={{ mt: 12, maxWidth: 1200, mx: 'auto', px: { xs: 2, sm: 3 }, pb: { md: 3 } }}>
      <Typography sx={{
        textAlign: 'center',
        fontFamily: 'playfair Display !important',
        maxWidth: 'xl',
        margin: '0 auto',
        mb: { xs: 0.5, md: 1 },
        color: "#680000",
        textTransform: "uppercase",
        letterSpacing: 1,
        fontSize: { xs: "24px !important", sm: "32px !important", md: "32px !important" },
        fontWeight: 600
      }}>Checkout</Typography>

      <Grid container spacing={3} sx={{ mt: 1 }}>
        {/* Left Column - Order Details */}
        <Grid item xs={12} lg={7}>
          {/* Order Type Card */}
          <Card sx={{ mb: 3, border: `1px solid ${primaryLight}` }}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                {orderType === 'delivery' ? (
                  <LocalShipping sx={{ color: primaryColor, mr: 2 }} />
                ) : (
                  <TakeoutDining sx={{ color: primaryColor, mr: 2 }} />
                )}
                <Box>
                  <Typography sx={{
                    fontSize: { xs: '0.9rem !important', sm: '1rem !important', md: '1.1rem !important' },
                    fontWeight: '600 !important',
                    color: '#680000'
                  }}>
                    {orderType === 'delivery' ? 'Delivery Order' : 'Takeaway Order'}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {selectedOutlet?.name || 'Selected Outlet'}
                  </Typography>
                </Box>
                <Chip
                  label={orderType === 'delivery' ? 'Delivery' : 'Takeaway'}
                  sx={{
                    ml: 'auto',
                    bgcolor: primaryLight,
                    color: primaryColor,
                    fontWeight: 600
                  }}
                />
              </Box>
              <Box sx={{ textAlign: 'center' }}>
                {orderType === 'delivery' &&
                  <FormControl>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={deliveryPeriod}
                      onChange={(e) => {
                        setDeliveryPeriod(e.target.value)
                      }}
                    >
                      <FormControlLabel value="now" control={
                        <Radio
                          sx={{
                            color: '#680000',
                            '&.Mui-checked': {
                              color: '#680000',
                            },
                          }}
                        />

                      } label="Delivery Now" />
                      <FormControlLabel value="later" control={<Radio
                        sx={{
                          color: '#680000',
                          '&.Mui-checked': {
                            color: '#680000',
                          },
                        }}
                      />} label="Delivery Later" />
                    </RadioGroup>
                  </FormControl>
                }
                {orderType === "delivery" && deliveryPeriod === "now" &&
                  <Typography sx={{ color: '#680000' }}> * Delivery Now Option will atleast take upto 40 mins from Order Created to Deliver</Typography>}
              </Box>
            </CardContent>
          </Card>

          {/* Contact Information */}
          <Card sx={{ mb: 3, border: `1px solid ${primaryLight}` }}>
            <CardContent>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  mb: expandedSection === 'contact' ? 2 : 0
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Person sx={{ color: primaryColor, mr: 2 }} />
                  <Typography sx={{
                    fontSize: { xs: '0.9rem !important', sm: '1rem !important', md: '1.1rem !important' },
                    fontWeight: '600 !important',
                    color: '#680000'
                  }}>
                    Contact Information
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  {expandedSection === 'contact' ? (
                    <IconButton
                      onClick={() => toggleSection('contact')}
                      size="small"
                      sx={{ color: primaryColor }}
                    >
                      <ExpandLess />
                    </IconButton>
                  ) : (validatedSteps.contact === true ? (
                    <Button
                      variant="outlined"
                      onClick={() => toggleSection('contact')}
                      sx={{
                        color: primaryColor,
                        fontSize: '12px !important',
                        borderColor: '#680000',
                        '&:hover': {
                          borderColor: '#680000',
                          backgroundColor: primaryLight,
                        }
                      }}
                    >
                      Change
                    </Button>
                  ) : (
                    <IconButton
                      onClick={() => toggleSection('contact')}
                      size="small"
                      sx={{ color: primaryColor }}
                    >
                      <ExpandMore />
                    </IconButton>
                  ))}
                </Box>
              </Box>

              <Collapse in={expandedSection === 'contact'}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      disabled={sessionStorage.getItem("user")}
                      label="Full Name"
                      value={form.customer_name}
                      onChange={e => setForm({ ...form, customer_name: e.target.value })}
                      error={!!fieldErrors.customer_name}
                      helperText={fieldErrors.customer_name}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <PhoneInput
                      country="sg"
                      specialLabel=""
                      value={form.customer_phone || ''}
                      onChange={(phone, country) => handleNumberChange("customer_phone", { target: { value: phone, countryValue: country } })}
                      inputStyle={{
                        width: '100%',
                        height: '50.25px',
                        borderRadius: '7px',
                        color: 'black',
                        paddingLeft: '58px',
                        fontSize: '12px !important',
                      }}
                      buttonStyle={{
                        borderTopLeftRadius: '7px',
                        borderBottomLeftRadius: '7px',
                      }}
                      containerStyle={{
                        width: '100%',
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      disabled={sessionStorage.getItem("user")}
                      fullWidth
                      label="Email"
                      value={form.customer_email}
                      onChange={e => setForm({ ...form, customer_email: e.target.value })}
                    />
                  </Grid>
                  <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                      variant="contained"
                      onClick={validateContactStep}
                      disabled={!isContactStepValid()}
                      sx={{
                        bgcolor: primaryColor,
                        '&:hover': {
                          bgcolor: primaryDark,
                        },
                        '&:disabled': {
                          bgcolor: 'grey.400',
                        }
                      }}
                    >
                      Continue
                    </Button>
                  </Grid>
                </Grid>
              </Collapse>
            </CardContent>
          </Card>

          {/* Delivery/Pickup Details */}
          {orderType === 'delivery' ? (
            <Card sx={{ mb: 3, border: `1px solid ${primaryLight}` }}>
              <CardContent>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    mb: expandedSection === 'delivery' ? 2 : 0
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <LocationOn sx={{ color: primaryColor, mr: 2 }} />
                    <Typography sx={{
                      fontSize: { xs: '0.9rem !important', sm: '1rem !important', md: '1.1rem !important' },
                      fontWeight: '600 !important',
                      color: '#680000'
                    }}>
                      Delivery Address
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {expandedSection === 'delivery' ? (
                      <IconButton
                        onClick={() => validatedSteps.contact && toggleSection('delivery')}
                        disabled={!validatedSteps.contact}
                        size="small"
                        sx={{
                          color: validatedSteps.contact ? primaryColor : 'grey.500',
                          '&:disabled': {
                            color: 'grey.500',
                          }
                        }}
                      >
                        <ExpandLess />
                      </IconButton>
                    ) : (
                      validatedSteps.delivery ?
                        (<Button
                          variant="outlined"
                          onClick={() => validatedSteps.contact && toggleSection('delivery')}
                          disabled={!validatedSteps.contact}
                          sx={{
                            fontSize: '12px !important',
                            color: validatedSteps.contact ? primaryColor : 'grey.500',
                            borderColor: '#680000',
                            '&:hover': {
                              borderColor: '#680000',
                              backgroundColor: primaryLight,
                            },
                            '&:disabled': {
                              color: 'grey.500',
                            }
                          }}
                        >
                          Change
                        </Button>) : (
                          <IconButton
                            onClick={() => validatedSteps.contact && toggleSection('delivery')}
                            disabled={!validatedSteps.contact}
                            size="small"
                            sx={{
                              color: validatedSteps.contact ? primaryColor : 'grey.500',
                              '&:disabled': {
                                color: 'grey.500',
                              }
                            }}
                          >
                            <ExpandMore />
                          </IconButton>)
                    )}
                  </Box>
                </Box>

                <Collapse in={expandedSection === 'delivery'}>
                  {!validatedSteps.contact ? (
                    <Alert severity="warning" sx={{ mt: 2 }}>
                      Please complete contact information first.
                    </Alert>
                  ) : (
                    <>
                      {deliveryPeriod === "later" &&
                        <Box sx={{ mb: 2 }}>
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <Box sx={{ display: 'flex', gap: 2, mt: 2, mb: 2, alignItems: 'center' }}>
                              <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                  sx={{ mt: '8px' }}
                                  label="Select Date"
                                  format='dd/MM/yyyy'
                                  value={selectedDate}
                                  onChange={(newValue) => {
                                    if (newValue) {

                                      setSelectedDate(newValue);
                                      setDeliveryTime(null);

                                      // Calculate time range for the new date
                                      const timeRange = calculatePickupTimeRange(newValue);
                                      setMinTime(timeRange.minDateTime);
                                      setMaxTime(timeRange.maxDateTime);
                                      handleDeliveryDateChange(newValue)
                                    }
                                  }}
                                  minDate={new Date()}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      sx={{ width: '30%' }}
                                      helperText="Select a date"
                                    />
                                  )}
                                />
                              </LocalizationProvider>
                              {!outletClosed &&
                              <TimeDropdown
                                label="Preferred Delivery Time"
                                value={deliveryTime ? deliveryTime.split(':').slice(0, 2).join(':') : ''}
                                onChange={(newTime) => {
                                  const fullTime = `${newTime}:00`;
                                  const isValid = isTimeGreaterThanOneHour(fullTime, selectedDate);

                                  if (isValid) {
                                    setDeliveryTime(fullTime);
                                    setIsTimeValid(true);
                                    setTimeError(false);
                                  } else {
                                    setDeliveryTime('');
                                    setIsTimeValid(false);
                                    setTimeError(true);
                                    showError('Please select a time that is at least 1 hour from now');
                                  }
                                }}
                                minTime={minTime}
                                maxTime={maxTime}
                                error={timeError && pickupTime === ''}
                                // helperText={minTime && maxTime
                                //   ? `Available: ${minTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - ${maxTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`
                                //   : 'Loading available times...'
                                // }
                                disabled={!selectedDate || outletClosed}
                              /> 
                              }
                              {/* {!outletClosed ?
                                <TimePicker
                                  sx={{ mt: 1 }}
                                  label="Preferred Delivery Time"
                                  value={deliveryTime ? (() => {
                                    const [hours, minutes] = deliveryTime.split(':').map(Number);
                                    const date = new Date(selectedDate);
                                    date.setHours(hours, minutes, 0, 0);
                                    return date;
                                  })() : null}
                                  onChange={(newValue) => {
                                    if (newValue) {
                                      const hours = newValue.getHours().toString().padStart(2, '0');
                                      const minutes = newValue.getMinutes().toString().padStart(2, '0');
                                      const newTime = `${hours}:${minutes}:00`;

                                      // Validate if time is at least 1 hour from now
                                      const isValid = isTimeGreaterThanOneHour(newTime, selectedDate);

                                      if (isValid) {
                                        setDeliveryTime(newTime);
                                        setIsTimeValid(true);
                                        setTimeError(false);
                                      } else {
                                        setDeliveryTime('');
                                        setIsTimeValid(false);
                                        setTimeError(true);
                                        showError('Please select a time that is at least 1 hour from now');
                                      }
                                    } else {
                                      setDeliveryTime('');
                                      setIsTimeValid(false);
                                      setTimeError(true);
                                    }
                                  }}
                                  minTime={minTime}
                                  maxTime={maxTime}
                                  minutesStep={15}
                                  disableIgnoringDatePartForTimeValidation
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      sx={{ width: '70%', mt: 1 }}
                                      error={timeError && deliveryTime === ''}
                                      helperText={minTime && maxTime
                                        ? `Available: ${minTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - ${maxTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`
                                        : 'Loading available times...'
                                      }
                                    />
                                  )}
                                  ampm={false}
                                /> : (
                                  <Typography sx={{ color: "#680000" }}>* The Outlet is Closed at the Selected Date , Please Select Another Date  </Typography>
                                )
                              } */}
                            </Box>
                          </LocalizationProvider>
                        </Box>}

                      {loginUser && savedAddresses.length > 0 && (
                        <Box sx={{ mb: 3 }}>
                          <Typography variant="h6" sx={{ mb: 2, fontSize: '1rem', fontWeight: 600 }}>
                            Select Saved Address
                          </Typography>
                          <Grid container spacing={2}>
                            {savedAddresses.map((address) => (
                              <Grid item xs={12} key={address.id}>
                                <Card
                                  sx={{
                                    border: selectedAddressId === address.id ? `2px solid ${primaryColor}` : `1px solid ${primaryLight}`,
                                    cursor: 'pointer',
                                    transition: 'all 0.2s',
                                    '&:hover': {
                                      borderColor: primaryColor,
                                    }
                                  }}
                                  onClick={() => handleAddressSelect(address)}
                                >
                                  <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                                    <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                      <Radio
                                        checked={selectedAddressId === address.id}
                                        onChange={() => handleAddressSelect(address)}
                                        value={address.id}
                                        name="saved-address"
                                        sx={{
                                          color: primaryColor,
                                          '&.Mui-checked': {
                                            color: primaryColor,
                                          },
                                          mt: -1
                                        }}
                                      />
                                      <Box sx={{ flex: 1 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                          <Typography variant="body1" fontWeight={600}>
                                            {address.address_name}
                                          </Typography>
                                          {address.is_default && (
                                            <Chip
                                              label="Default"
                                              size="small"
                                              sx={{
                                                ml: 1,
                                                bgcolor: primaryLight,
                                                color: primaryColor,
                                                fontSize: '0.7rem',
                                                height: 20
                                              }}
                                            />
                                          )}
                                        </Box>
                                        <Typography variant="body2" color="text.secondary">
                                          {address.unit_number}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                          {address.building_name}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                          {address.block_number_and_street_name}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                          {address.pincode}
                                        </Typography>
                                      </Box>
                                    </Box>
                                  </CardContent>
                                </Card>
                              </Grid>
                            ))}
                          </Grid>

                          {selectedAddressId && (
                            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                              <Button
                                variant="outlined"
                                size="small"
                                onClick={handleClearSelectedAddress}
                                sx={{
                                  color: primaryColor,
                                  borderColor: primaryColor,
                                  '&:hover': {
                                    borderColor: primaryDark,
                                    backgroundColor: primaryLight,
                                  }
                                }}
                              >
                                Use Different Address
                              </Button>
                            </Box>
                          )}

                          <Divider sx={{ my: 3 }} />

                          {loginUser && selectedAddressId &&
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                              {editSavedAddress &&
                                <Button variant='contained' sx={{
                                  bgcolor: primaryColor,
                                  color: '#fff',
                                  '&:hover': {
                                    bgcolor: primaryDark, // Slightly lighter/darker red
                                  },
                                }} onClick={handleUpdateAddress}>
                                  Update Address
                                </Button>}

                              <IconButton sx={{ color: '#680000' }} onClick={() => {
                                let flag = !editSavedAddress
                                setEditSavedAddress(flag)
                              }}> {!editSavedAddress ? <Edit /> : <Clear />}</IconButton>
                            </Box>}
                        </Box>
                      )}

                      {/* Address Form */}
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            fullWidth
                            label="Pin Code"
                            value={form.pincode}
                            onChange={async (e) => {
                              const value = e.target.value;

                              setForm(prev => ({
                                ...prev,
                                pincode: value
                              }));

                              if (value.length === 6 || form.pincode.length === 6) {
                                const authResponse = await getAuth();
                                localStorage.setItem("oneMapToken", authResponse.data.token);

                                const payload = {
                                  pincode: value,
                                  token: authResponse.data.token
                                };

                                const response = await getAddressUsingPincode(payload);
                                const result = response.data.results?.[0];
                                let distance_payload = {
                                  "pincode": value,
                                  "latitude": result?.LATITUDE,
                                  "longitude": result?.LONGITUDE,
                                  "outlet_id": selectedOutlet.id
                                }
                                try {
                                  const distanceResponse = await get_distance_data(distance_payload)
                                  setlalamoveIsEnabled(distanceResponse?.lalamove)
                                  setLalamoveDeliveryFee(distanceResponse?.priceBreakdown?.total)
                                  if (taxInfo?.lalamove) {
                                    setDeliveryFee(parseFloat(distanceResponse?.priceBreakdown?.total))
                                  }
                                  else {
                                    setDeliveryFee(taxInfo?.delivery_fee)
                                  }
                                }
                                catch (error) {
                                  // showError("Please Enter a Valid Pincode")
                                }

                                if (result) {
                                  setForm(prev => ({
                                    ...prev,
                                    pincode: value,
                                    building_name: result.BUILDING,
                                    block_number_and_street_name: result.ADDRESS,
                                  }));
                                }
                              }
                              else {
                                setDeliveryFee(taxInfo?.delivery_fee)

                              }
                            }}
                            error={!!fieldErrors.pincode}
                            helperText={fieldErrors.pincode}
                            required
                            inputProps={{ maxLength: 6 }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={8}>
                          <TextField
                            disabled={selectedAddressId && !editSavedAddress}
                            fullWidth
                            label="Building Name"
                            value={form.building_name}
                            onChange={e => setForm({ ...form, building_name: e.target.value })}
                            error={!!fieldErrors.building_name}
                            helperText={fieldErrors.building_name}
                            required
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            disabled={selectedAddressId && !editSavedAddress}
                            fullWidth
                            label="Block Number & Street Name"
                            value={form.block_number_and_street_name}
                            onChange={e => setForm({ ...form, block_number_and_street_name: e.target.value })}
                            error={!!fieldErrors.block_number_and_street_name}
                            helperText={fieldErrors.block_number_and_street_name}
                            required
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            disabled={selectedAddressId && !editSavedAddress}
                            fullWidth
                            label="Unit Number"
                            value={form.unit_number}
                            onChange={e => setForm({ ...form, unit_number: e.target.value })}
                            error={!!fieldErrors.unit_number}
                            helperText={fieldErrors.unit_number}
                            required
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            disabled={selectedAddressId && !editSavedAddress}
                            fullWidth
                            multiline
                            minRows={2}
                            label="Delivery Instructions (optional)"
                            value={form.delivery_instructions}
                            onChange={e => setForm({ ...form, delivery_instructions: e.target.value })}
                          />
                        </Grid>
                        {loginUser && (
                          <Grid item xs={12}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={addressChecked}
                                  onChange={(e) => setAddressChecked(e.target.checked)}
                                  name="address"
                                  sx={{ color: primaryColor }}
                                />
                              }
                              label="Save this address for future orders"
                            />
                            {addressChecked && (
                              <TextField
                                fullWidth
                                size="small"
                                placeholder="Address Name (e.g., Home, Office)"
                                value={addressName}
                                onChange={(e) => setAddresName(e.target.value)}
                                sx={{ mt: 1 }}
                              />
                            )}
                          </Grid>
                        )}
                        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                          <Button
                            variant="contained"
                            onClick={validateDeliveryStep}
                            disabled={!isDeliveryStepValid()}
                            sx={{
                              bgcolor: primaryColor,
                              '&:hover': {
                                bgcolor: primaryDark,
                              },
                              '&:disabled': {
                                bgcolor: 'grey.400',
                              }
                            }}
                          >
                            Continue
                          </Button>
                        </Grid>
                      </Grid>
                    </>
                  )}
                </Collapse>
              </CardContent>
            </Card>
          ) : (
            <Card sx={{ mb: 3, border: `1px solid ${primaryLight}` }}>
              <CardContent>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    mb: expandedSection === 'delivery' ? 2 : 0
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Schedule sx={{ color: primaryColor, mr: 2 }} />
                    <Typography sx={{
                      fontSize: { xs: '0.9rem !important', sm: '1rem !important', md: '1.1rem !important' },
                      fontWeight: '600 !important',
                      color: '#680000'
                    }}>
                      Pickup Time
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {expandedSection === 'delivery' ? (
                      <IconButton
                        onClick={() => validatedSteps.contact && toggleSection('delivery')}
                        disabled={!validatedSteps.contact}
                        size="small"
                        sx={{
                          color: validatedSteps.contact ? primaryColor : 'grey.500',
                          '&:disabled': {
                            color: 'grey.500',
                          }
                        }}
                      >
                        <ExpandLess />
                      </IconButton>
                    ) : (
                      validatedSteps.delivery ? (
                        <Button
                          variant="outlined"
                          onClick={() => validatedSteps.contact && toggleSection('delivery')}
                          disabled={!validatedSteps.contact}
                          sx={{
                            borderColor: '#680000',
                            fontSize: '12px !important',
                            color: validatedSteps.contact ? primaryColor : 'grey.500',
                            '&:hover': {
                              borderColor: '#680000',
                              backgroundColor: primaryLight,
                            },
                            '&:disabled': {
                              color: 'grey.500',
                            }
                          }}
                        >
                          Change
                        </Button>) :
                        (<IconButton
                          onClick={() => validatedSteps.contact && toggleSection('delivery')}
                          disabled={!validatedSteps.contact}
                          size="small"
                          sx={{
                            color: validatedSteps.contact ? primaryColor : 'grey.500',
                            '&:disabled': {
                              color: 'grey.500',
                            }
                          }}
                        >
                          <ExpandMore />
                        </IconButton>)
                    )}
                  </Box>
                </Box>

                <Collapse in={expandedSection === 'delivery'}>
                  {!validatedSteps.contact ? (
                    <Alert severity="warning" sx={{ mt: 2 }}>
                      Please complete contact information first.
                    </Alert>
                  ) : (
                    <>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <Box sx={{ display: 'flex', gap: 2, mt: 2, mb: 2 }}>
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                              sx={{ mt: '8px' }}
                              label="Select Date"
                              format='dd/MM/yyyy'
                              value={selectedDate}
                              onChange={(newValue) => {
                                if (newValue) {
                                  setSelectedDate(newValue);
                                  setPickupTime(null);
                                  // Calculate time range for the new date
                                  const timeRange = calculatePickupTimeRange(newValue);
                                  setMinTime(timeRange.minDateTime);
                                  setMaxTime(timeRange.maxDateTime);
                                  handleDeliveryDateChange(newValue)
                                }
                              }}
                              minDate={new Date()}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  sx={{ width: '30%' }}
                                  helperText="Select a date"
                                />
                              )}
                            />
                          </LocalizationProvider>
                          {!outletClosed ?
                            <TimeDropdown
                              label="Preferred Pickup Time"
                              value={pickupTime ? pickupTime.split(':').slice(0, 2).join(':') : ''}
                              onChange={(newTime) => {
                                const fullTime = `${newTime}:00`;
                                const isValid = isTimeGreaterThanOneHour(fullTime, selectedDate);

                                if (isValid) {
                                  setPickupTime(fullTime);
                                  setIsTimeValid(true);
                                  setTimeError(false);
                                } else {
                                  setPickupTime('');
                                  setIsTimeValid(false);
                                  setTimeError(true);
                                  showError('Please select a time that is at least 1 hour from now');
                                }
                              }}
                              minTime={minTime}
                              maxTime={maxTime}
                              error={timeError && pickupTime === ''}
                              // helperText={minTime && maxTime
                              //   ? `Available: ${minTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - ${maxTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`
                              //   : 'Loading available times...'
                              // }
                              disabled={!selectedDate || outletClosed}
                            /> : (
                              <Typography sx={{ color: "#680000" }}>* The Outlet is Closed at the Selected Date , Please Select Another Date  </Typography>
                            )
                          }
                        </Box>
                        <Grid item xs={12} sx={{ mb: 2 }}>
                          <TextField
                            fullWidth
                            multiline
                            minRows={2}
                            label="Remarks (optional)"
                            value={form.delivery_instructions}
                            onChange={e => setForm({ ...form, delivery_instructions: e.target.value })}
                          />
                        </Grid>
                      </LocalizationProvider>
                      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                          variant="contained"
                          onClick={validateDeliveryStep}
                          disabled={!isDeliveryStepValid()}
                          sx={{
                            bgcolor: primaryColor,
                            '&:hover': {
                              bgcolor: primaryDark,
                            },
                            '&:disabled': {
                              bgcolor: 'grey.400',
                            }
                          }}
                        >
                          Continue
                        </Button>
                      </Box>
                    </>
                  )}
                </Collapse>
              </CardContent>
            </Card>
          )}

          {/* Payment Method */}
          <Card sx={{ border: `1px solid ${primaryLight}`, mb: '10px' }}>
            <CardContent>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  mb: expandedSection === 'payment' ? 2 : 0
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Payment sx={{ color: primaryColor, mr: 2 }} />
                  <Typography sx={{
                    fontSize: { xs: '0.9rem !important', sm: '1rem !important', md: '1.1rem !important' },
                    fontWeight: '600 !important',
                    color: '#680000'
                  }}>
                    Payment Method
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  {expandedSection === 'payment' ? (
                    <IconButton
                      onClick={() => validatedSteps.delivery && toggleSection('payment')}
                      disabled={!validatedSteps.delivery}
                      size="small"
                      sx={{
                        color: validatedSteps.delivery ? primaryColor : 'grey.500',
                        '&:disabled': {
                          color: 'grey.500',
                        }
                      }}
                    >
                      <ExpandLess />
                    </IconButton>
                  ) : (
                    validatedSteps.payment ? (
                      <Button
                        variant="outlined"
                        onClick={() => validatedSteps.delivery && toggleSection('payment')}
                        disabled={!validatedSteps.delivery}
                        sx={{
                          borderColor: '#680000',
                          fontSize: '12px !important',
                          color: validatedSteps.delivery ? primaryColor : 'grey.500',
                          '&:hover': {
                            borderColor: '#680000',
                            backgroundColor: primaryLight,
                          },
                          '&:disabled': {
                            color: 'grey.500',
                          }
                        }}
                      >
                        Change
                      </Button>) :
                      (
                        <IconButton
                          onClick={() => validatedSteps.delivery && toggleSection('payment')}
                          disabled={!validatedSteps.delivery}
                          size="small"
                          sx={{
                            color: validatedSteps.delivery ? primaryColor : 'grey.500',
                            '&:disabled': {
                              color: 'grey.500',
                            }
                          }}
                        >
                          <ExpandMore />
                        </IconButton>
                      )
                  )}
                </Box>
              </Box>

              <Collapse in={expandedSection === 'payment'}>
                {!validatedSteps.delivery ? (
                  <Alert severity="warning" sx={{ mt: 2 }}>
                    Please complete delivery information first.
                  </Alert>
                ) : (
                  <>
                    <FormControl component="fieldset" fullWidth error={!!fieldErrors.payment}>
                      <RadioGroup
                        value={paymentMethod}
                        onChange={(e) => {
                          setPaymentMethod(e.target.value);
                          setFieldErrors(prev => ({ ...prev, payment: '' }));
                        }}
                      >
                        <FormControlLabel
                          value="paynow"
                          control={<Radio
                            sx={{
                              color: '#680000',
                              '&.Mui-checked': {
                                color: '#680000',
                              },
                            }}
                          />}
                          label={
                            <Box>
                              <Typography fontWeight={600}>PayNow</Typography>
                              <Typography variant="body2" color="text.secondary">
                                Instant bank transfer
                              </Typography>
                            </Box>
                          }
                          sx={{ mb: 1, p: 1, borderRadius: 1, bgcolor: paymentMethod === 'paynow' ? primaryLight : 'transparent' }}
                        />
                        {/* <FormControlLabel
                          value="grabpay"
                          control={<Radio
                            sx={{
                              color: '#680000',
                              '&.Mui-checked': {
                                color: '#680000',
                              },
                            }}
                          />}
                          label={
                            <Box>
                              <Typography fontWeight={600}>GrabPay</Typography>
                              <Typography variant="body2" color="text.secondary">
                                Pay with GrabPay wallet
                              </Typography>
                            </Box>
                          }
                          sx={{ mb: 1, p: 1, borderRadius: 1, bgcolor: paymentMethod === 'grabpay' ? primaryLight : 'transparent' }}
                        /> */}
                        <FormControlLabel
                          value="card"
                          control={<Radio
                            sx={{
                              color: '#680000',
                              '&.Mui-checked': {
                                color: '#680000',
                              },
                            }}
                          />}
                          label={
                            <Box>
                              <Typography fontWeight={600}>Credit/Debit Card</Typography>
                              <Typography variant="body2" color="text.secondary">
                                Secure card payment
                              </Typography>
                            </Box>
                          }
                          sx={{ mb: 1, p: 1, borderRadius: 1, bgcolor: paymentMethod === 'card' ? primaryLight : 'transparent' }}
                        />
                        {/* <FormControlLabel
                          value="upi"
                          control={<Radio
                            sx={{
                              color: '#680000',
                              '&.Mui-checked': {
                                color: '#680000',
                              },
                            }}
                          />}
                          label={
                            <Box>
                              <Typography fontWeight={600}>UPI Payment</Typography>
                              <Typography variant="body2" color="text.secondary">
                                Fast UPI transfer
                              </Typography>
                            </Box>
                          }
                          sx={{ mb: 1, p: 1, borderRadius: 1, bgcolor: paymentMethod === 'upi' ? primaryLight : 'transparent' }}
                        /> */}
                        {/* <FormControlLabel
                          value="cash_on_delivery"
                          control={<Radio     
                            sx={{
                              color: '#680000',
                              '&.Mui-checked': {
                                color: '#680000',
                              },
                            }}
                          />}
                          label={
                            <Box>
                              <Typography fontWeight={600}>
                                {orderType === 'delivery' ? 'Cash on Delivery' : 'Cash on Pickup'}
                              </Typography>
                              <Typography variant="body2" color="text.secondary">
                                Pay when you receive your order
                              </Typography>
                            </Box>
                          }
                          sx={{ p: 1, borderRadius: 1, bgcolor: paymentMethod === 'cash_on_delivery' ? primaryLight : 'transparent' }}
                        /> */}
                      </RadioGroup>
                      {fieldErrors.payment && (
                        <Typography variant="caption" color="error" sx={{ mt: 1, display: 'block' }}>
                          {fieldErrors.payment}
                        </Typography>
                      )}
                    </FormControl>
                    {!validatedSteps.payment &&
                      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                        <Button
                          variant="contained"
                          onClick={validatePaymentStep}
                          disabled={!isPaymentStepValid()}
                          sx={{
                            bgcolor: primaryColor,
                            '&:hover': {
                              bgcolor: primaryDark,
                            },
                            '&:disabled': {
                              bgcolor: 'grey.400',
                            }
                          }}
                        >
                          Continue
                        </Button>
                      </Box>
                    }
                  </>
                )}
              </Collapse>
            </CardContent>
          </Card>
        </Grid>

        {/* Right Column - Order Summary */}
        <Grid item xs={12} lg={5} sx={{ pb: 2, pr: 1, pt: 5 }}>
          <Card sx={{
            position: 'sticky',
            top: 100,
            border: 'none',
            borderRadius: 2,
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
          }}>
            <CardContent>
              <Typography variant="h5" fontWeight={700} gutterBottom color={primaryColor}>
                Order Summary
              </Typography>

              {/* Cart Items */}
              <Box sx={{ mb: 2 }}>
                {cartItems.map((item, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'flex-start',
                      py: 2,
                      borderBottom: index < cart.length - 1 ? '1px solid' : 'none',
                      borderColor: 'grey.200'
                    }}
                  >
                    {/* Item Image and Name */}
                    <Box sx={{ display: 'flex', alignItems: 'flex-start', flex: 1, gap: 2 }}>
                      {/* Item Image Placeholder */}
                      <Box
                        sx={{
                          width: 60,
                          height: 60,
                          bgcolor: primaryLight,
                          borderRadius: 1,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexShrink: 0,
                          overflow: 'hidden',
                          position: 'relative'
                        }}
                      >
                        {item?.image_url ? (
                          <img
                            src={item.image_url}
                            alt={item.name}
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover'
                            }}
                            onError={(e) => {
                              e.target.style.display = 'none';
                            }}
                          />
                        ) : (
                          <Typography variant="caption" fontWeight={600} color={primaryColor}>
                            IMG
                          </Typography>
                        )}
                      </Box>

                      <Box sx={{ flex: 1 }}>
                        <Typography variant="body1" fontWeight={600} sx={{ mb: 0.5 }}>
                          {item.name}
                        </Typography>
                        {item.selectedSize && (
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
                            Size: {item.selectedSize.name}
                          </Typography>
                        )}
                        {item.addons && item.addons.length > 0 && (
                          <>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                              sx={{ display: 'block' }}
                            >
                              Add-ons:
                            </Typography>

                            {item.addons.map((addon, index) => (
                              <Typography
                                key={index}
                                variant="caption"
                                color="text.secondary"
                                sx={{ display: 'block', ml: 1 }}
                              >
                                • {addon.name} - S${addon.price}
                              </Typography>
                            ))}
                          </>
                        )}
                        {item.special_instructions && (
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', fontStyle: 'italic' }}>
                            Note: {item.special_instructions}
                          </Typography>
                        )}

                        {/* Quantity Controls */}
                        <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                          <Typography variant="body2" fontWeight={600} sx={{ minWidth: 20, textAlign: 'center' }}>
                            Qty:
                          </Typography>
                          <Typography variant="body2" fontWeight={600} sx={{ minWidth: 20, textAlign: 'center' }}>
                            {item.quantity}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>

                    {/* Price */}
                    <Box sx={{ textAlign: 'right', minWidth: 80 }}>
                      <Typography variant="body1" fontWeight={600} color={primaryColor}>
                        S${((item.price || item.base_price || 0) * (item.quantity || 1)).toFixed(2)}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        S${(item.price || item.base_price || 0).toFixed(2)} each
                      </Typography>
                    </Box>
                  </Box>
                ))}
              </Box>

              <Divider sx={{ my: 2 }} />

              {/* Price Breakdown */}
              <Box sx={{ mb: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Typography sx={{
                    fontSize: { xs: '0.875rem !important', sm: '0.9rem !important', md: '1rem !important' },
                    textAlign: "left",
                    color: '#1A1A1A',
                    fontWeight: '500 !important',
                    mt: 0.5,
                    mb: 1
                  }}>Subtotal</Typography>
                  <Typography sx={{
                    fontSize: { xs: '0.875rem !important', sm: '0.9rem !important', md: '1rem !important' },
                    color: '#1A1A1A',
                    fontWeight: '600 !important',
                    mt: 0.5,
                    mb: 1
                  }}>S${summary.subtotal.toFixed(2)}</Typography>
                </Box>

                {orderType === 'delivery' && (taxInfo?.free_delivery === 0 || (taxInfo.free_delivery > 0 && summary.subtotal < taxInfo?.free_delivery)) && (
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Typography sx={{
                      fontSize: { xs: '0.875rem !important', sm: '0.9rem !important', md: '1rem !important' },
                      color: '#1A1A1A',
                      fontWeight: '500 !important',
                      mt: 0.5,
                      mb: 1
                    }}>Delivery Fee</Typography>
                    <Typography sx={{
                      fontSize: { xs: '0.875rem !important', sm: '0.9rem !important', md: '1rem !important' },
                      color: '#1A1A1A',
                      fontWeight: '600 !important',
                      mt: 0.5,
                      mb: 1
                    }}>
                      {form.pincode?.length === 6 ? `S$${deliveryFee.toFixed(2)}` : "-"}
                    </Typography>
                  </Box>
                )}

                {taxInfo?.gst > 0 &&
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Typography sx={{
                      fontSize: { xs: '0.875rem !important', sm: '0.9rem !important', md: '1rem !important' },
                      color: '#1A1A1A',
                      fontWeight: '500 !important',
                      mt: 0.5,
                      mb: 1
                    }}>Taxes (GST)</Typography>
                    <Typography sx={{
                      fontSize: { xs: '0.875rem !important', sm: '0.9rem !important', md: '1rem !important' },
                      color: '#1A1A1A',
                      fontWeight: '600 !important',
                      mt: 0.5,
                      mb: 1
                    }}>S${summary.gst_value}</Typography>
                  </Box>
                }

                {taxInfo?.service_charge > 0 &&
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Typography sx={{
                      fontSize: { xs: '0.875rem !important', sm: '0.9rem !important', md: '1rem !important' },
                      color: '#1A1A1A',
                      fontWeight: '500 !important',
                      mt: 0.5,
                      mb: 1
                    }}>Service Charge</Typography>
                    <Typography sx={{
                      fontSize: { xs: '0.875rem !important', sm: '0.9rem !important', md: '1rem !important' },
                      color: '#1A1A1A',
                      fontWeight: '600 !important',
                      mt: 0.5,
                      mb: 1
                    }}>S${summary.serviceChargeValue}</Typography>
                  </Box>
                }

                {paymentMethod !== "cash_on_delivery" && paymentMethod !== "" &&  summary.platform_fee > 0 &&(
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Typography sx={{
                      fontSize: { xs: '0.875rem !important', sm: '0.9rem !important', md: '1rem !important' },
                      color: '#1A1A1A',
                      fontWeight: '500 !important',
                      mt: 0.5,
                      mb: 1
                    }}>Platform Fee</Typography>
                    <Typography sx={{
                      fontSize: { xs: '0.875rem !important', sm: '0.9rem !important', md: '1rem !important' },
                      color: '#1A1A1A',
                      fontWeight: '600 !important',
                      mt: 0.5,
                      mb: 1
                    }}>
                      S${summary.platform_fee.toFixed(2)}
                    </Typography>
                  </Box>
                )}
              </Box>

              <Divider sx={{ my: 2 }} />

              {/* Total */}
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
                <Typography variant="h6" fontWeight={700}>Total</Typography>
                <Typography variant="h6" fontWeight={700} color={primaryColor}>
                  S${summary.total_amount.toFixed(2)}
                </Typography>
              </Box>

              {/* Place Order Button */}
              <Button
                disabled={submitting || !paymentMethod || cart.length === 0 || !validatedSteps.contact || !validatedSteps.delivery || !validatedSteps.payment}
                onClick={handlePlaceOrder}
                fullWidth
                size="large"
                variant="contained"
                sx={{
                  bgcolor: primaryColor,
                  borderRadius: 2,
                  textTransform: 'none',
                  fontWeight: 700,
                  fontSize: '1.1rem',
                  py: 1.5,
                  '&:hover': {
                    bgcolor: primaryDark,
                  },
                  '&:disabled': {
                    bgcolor: 'grey.400',
                  }
                }}
              >
                {submitting ? 'Processing...' :
                  cart.length === 0 ? 'Cart is Empty' :
                    !validatedSteps.contact || !validatedSteps.delivery || !validatedSteps.payment ? 'Complete All Steps' :
                      'Place Order'}
              </Button>

              {/* Security Message */}
              <Typography variant="caption" color="text.secondary" sx={{ textAlign: 'center', display: 'block', mt: 2 }}>
                🔒 Your payment information is secure and encrypted
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <CommonModal modalOpen={paymentRedirectModalOpen} setModalOpen={setPaymentRedirectModalOpen} children={<PaymentRedirectModal status={paymentStatus} setPaymentStatus={setPaymentStatus} modalOpen={paymentRedirectModalOpen} setModalOpen={setPaymentRedirectModalOpen} navigateFunction={navigateAfterSuccess} />} onclose={false} />

      <CommonModal modalOpen={deliveryNowModalOpen} setModalOpen={setDeliveryNowModalOpen} children={< DeliveryNowWarningModal deliveryNowModalOpen={deliveryNowModalOpen} setDeliveryNowModalOpen={setDeliveryNowModalOpen} outletOpeningTime={outletOpeningTime} />} onclose={false} />

    </Box>
  );
};

const PaymentRedirectModal = ({ status, setPaymentStatus, modalOpen, setModalOpen, navigateFunction }) => {
  const navigate = useNavigate();
  useEffect(() => {
    // console.log("Status After Completing Payment => ", status)
    if (status === "completed") {
      setTimeout(() => {
        navigateFunction();
      }, 2000);
    }
  }, [])

  if (status === "canceled") {
    return (
      <Box
        sx={{
          position: 'relative',
          textAlign: 'center',
          p: 3
        }}
      >
        {/* Close Button */}
        <IconButton
          onClick={() => {
            navigate('/checkout')
            setPaymentStatus("")
            setModalOpen(false)
          }}
          sx={{
            position: 'absolute',
            bottom: 115,
            right: 8
          }}
        >
          <Close />
        </IconButton>

        <Error sx={{ fontSize: '48px !important', color: 'error.main' }} />

        <Typography sx={{ fontSize: '28px !important', fontWeight: 600 }}>
          Payment Failed
        </Typography>
        <Typography sx={{ fontSize: '14px !important', fontWeight: 100 }}>
          * Your order has not been placed. Please try again to place your order.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ textAlign: "center", height: '100px' }}>
      <CircularProgress color="secondary" />
      <Typography variant='h5'>Please Don't Refresh or Click Back Button until Payment Completed</Typography>
    </Box>
  )
}


const DeliveryNowWarningModal = ({ deliveryNowModalOpen, setDeliveryNowModalOpen, outletOpeningTime }) => {
  return (
    <>
      <Box sx={{ textAlign: 'center' }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <Fastfood sx={{ fontSize: '30px !important' }} />
        </Box>
        <Typography variant='h4' sx={{ mb: 2 }}>Outlet Opening Time : {outletOpeningTime}</Typography>
        <Typography variant='h5'>
          Outlet is currently closed. Delivery Now will be scheduled for 40 minutes after opening. For a different time, please select Delivery Later.
        </Typography>
        <Button
          variant="contained"
          onClick={() => setDeliveryNowModalOpen(false)}
          sx={{
            mt: 2,
            bgcolor: '#680000',
            '&:hover': {
              bgcolor: '#8a0000',

            }
          }}
        >
          Continue
        </Button>
      </Box>
    </>
  )
}

export default CheckoutPage;